<template>
  <div class="plugin-layout">
    <div class="extension-header-new">
      <div class="flex items-center justify-between" data-testid="company-logo">
        <a target="_blank" href="https://app.whitecarrot.io/">
          <CompanyWcLogo :isExtension="true" :partner="companyPartner" :text="companyPartnerText"></CompanyWcLogo>
        </a>
        <LanguageSwitcher />
        <div id="close" class="icon-btn cursor-pointer" @click="closeMe">
          <svg class="icon-close" width="16px" height="16px" viewBox="0 0 16 16">
            <path d="M0 1.6L1.6 0 8 6.4 14.4 0 16 1.6 9.6 8 16 14.4 14.4 16 8 9.6 1.6 16 0 14.4 6.4 8 0 1.6z"></path>
          </svg>
        </div>
      </div>
    </div>
    <div class="min-h-screen">
      <RouterView />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { WhiteLabelPartnerEnum } from '@/views/dashboard/dashboard-model'
import CompanyWcLogo from '@/views/logos/company-wc-logo.vue'
import LanguageSwitcher from '@/components/UILibrary/LanguageSwitcher.vue'

@Component({
  name: 'PluginLayout',
  components: { LanguageSwitcher, CompanyWcLogo },
  computed: {
    WhiteLabelPartnerEnum() {
      return WhiteLabelPartnerEnum
    }
  },
  methods: {
    UserModule() {
      return UserModule
    }
  }
})
export default class extends Vue {
  closeMe() {
    const iframe = document.getElementsByClassName('lever-hire-frame')[0]
    if (iframe) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      iframe.contentWindow.postMessage({ type: 'togglePanel' }, '*')
    }
    try {
      window.postMessage({ type: 'togglePanel' }, '*')
    } catch (e) {
    }

    try {
      parent.postMessage({ type: 'togglePanel' }, '*')
    } catch (e) {
    }
    try {
      window.parent.postMessage({ action: 'wc-closeIframe' }, '*')
    } catch (e) {
    }
  }

  get companyPartnerText() {
    if (UserModule.whiteLabelPartner === WhiteLabelPartnerEnum.BAYZAT) {
      return 'Bayzat ATS'
    } else {
      return 'Whitecarrot ATS'
    }
  }

  get companyPartner() {
    return UserModule.whiteLabelPartner as WhiteLabelPartnerEnum
  }
}
</script>

<style lang="scss">
.plugin-layout{
  .extension-header-new{
    //background-color: whitesmoke;
    padding: 10px;
    .icon-logo{
      width: 150px;
    }
  }
}

.plugin-layout {
  height: 100%;
}
@media (max-width: 768px) {
  .icon-btn {
    display: inherit;
  }
}
@media (min-width: 768px) {
  .icon-btn {
    display: none;
  }
}
</style>
